import * as React from 'react';
import { getObserver } from './utils';

interface IElementInViewportProps {
  children: React.ReactNode;
  threshold: number;
  onVisible(): void;
}

export class ElementInViewport extends React.Component<IElementInViewportProps, {}> {
  private containerRef = React.createRef<HTMLDivElement>();
  private detachObserver = () => {};

  public componentDidMount() {
    const containerNode = this.containerRef.current;
    const { threshold, onVisible } = this.props;

    if (!containerNode) {
      return;
    }

    const observer = getObserver();

    this.detachObserver = observer({
      target: containerNode,
      threshold,
      onVisible,
    });
  }

  public componentWillUnmount() {
    this.detachObserver();
  }

  public render() {
    const { children } = this.props;

    return <div ref={this.containerRef}>{children}</div>;
  }
}
